<div class="flex flex-col space-y-8">
    <form [formGroup]="orderDetailsForm" class="flex flex-col space-y-8">
        <div class="flex gap-5">
            <div class="flex-1 min-w-0">
                <app-order-summary-header
                    [orderSummaryData]="orderDetails"
                    [cityStateZip]="cityStateZip"
                    [showEditButton]="!isReadOnly()"
                    (editBillingInformation)="
                        handleEditBillingInformationClick()
                    "
                ></app-order-summary-header>
            </div>

            <div
                class="w-4/12 lg:w-3/12 2xl:w-2/12 flex flex-col-reverse gap-3"
            >
                <mat-form-field
                    appearance="outline"
                    class="w-full"
                    subscriptSizing="dynamic"
                >
                    <mat-label>PO Number</mat-label>
                    <input
                        matInput
                        [formControl]="poNumber"
                        placeholder="Enter PO Number"
                        maxlength="{{ orderConstants.MAX_PO_NUMBER_LENGTH }}"
                        [appRegexInput]="
                            regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                        "
                    />
                </mat-form-field>
                @if (hasElevatedRole()) {
                    <mat-form-field
                        appearance="outline"
                        class="w-full"
                        subscriptSizing="dynamic"
                    >
                        <mat-label>Status</mat-label>
                        <mat-select [formControl]="status" panelWidth="w-full">
                            @for (
                                orderStatus of orderStatusDropdownOptions;
                                track orderStatus.value
                            ) {
                                <mat-option
                                    [value]="orderStatus.value"
                                    [disabled]="orderStatus.disabled"
                                >
                                    {{ orderStatus.label }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                }
            </div>
        </div>

        <div class="w-full">
            @if (hasElevatedRole() && !isReadOnly()) {
                <div class="flex justify-end mb-2">
                    <button
                        mat-flat-button
                        color="primary"
                        class="!rounded-lg !px-6 !py-0 !m-0"
                        (click)="handleAddOrderLineItemClick()"
                        type="button"
                    >
                        Add Item
                    </button>
                </div>
            }
            @if (hasElevatedRole()) {
                <app-grid-toolbar
                    [gridApi]="
                        gridApis[orderDetailsGridType.orderLineItemsEditable]
                    "
                    [options]="orderLineItemGridToolbarOptions"
                ></app-grid-toolbar>
                <ag-grid-angular
                    id="order-line-items-editable-grid"
                    [context]="
                        initializeGridContext(
                            orderDetailsGridType.orderLineItemsEditable
                        )
                    "
                    [rowData]="
                        rowData[orderDetailsGridType.orderLineItemsEditable]
                    "
                    [gridOptions]="orderLineItemsEditableGridOptions"
                    (gridReady)="
                        onGridReady(
                            $event,
                            orderDetailsGridType.orderLineItemsEditable
                        )
                    "
                    class="ag-theme-quartz w-full"
                ></ag-grid-angular>
            } @else {
                <app-grid-toolbar
                    [gridApi]="
                        gridApis[orderDetailsGridType.orderLineItemsReadonly]
                    "
                    [options]="orderLineItemGridToolbarOptions"
                ></app-grid-toolbar>
                <ag-grid-angular
                    id="order-line-items-readonly-grid"
                    [context]="
                        initializeGridContext(
                            orderDetailsGridType.orderLineItemsReadonly
                        )
                    "
                    [rowData]="
                        rowData[orderDetailsGridType.orderLineItemsReadonly]
                    "
                    [gridOptions]="orderLineItemsReadonlyGridOptions"
                    (gridReady)="
                        onGridReady(
                            $event,
                            orderDetailsGridType.orderLineItemsReadonly
                        )
                    "
                    class="ag-theme-quartz w-full"
                ></ag-grid-angular>
            }
            <ag-grid-angular
                id="order-financial-summary-grid"
                [context]="
                    initializeGridContext(
                        orderDetailsGridType.orderFinancialSummary
                    )
                "
                [rowData]="rowData[orderDetailsGridType.orderFinancialSummary]"
                [gridOptions]="orderFinancialSummaryGridOptions"
                (gridReady)="
                    onGridReady(
                        $event,
                        orderDetailsGridType.orderFinancialSummary
                    )
                "
                class="ag-theme-quartz w-full"
            ></ag-grid-angular>
        </div>

        @if (hasElevatedRole()) {
            <div class="w-full">
                <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                        <mat-panel-title
                            class="!text-tertiary-900 font-normal !text-xl py-2"
                        >
                            EWA Order Notes (Internal Use Only)
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <mat-form-field appearance="outline" class="w-full">
                        <textarea
                            [formControl]="notes"
                            title="EWA Order Notes"
                            matInput
                            maxlength="{{
                                orderDetailsConstants.MAX_NOTES_LENGTH
                            }}"
                            [appRegexInput]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                            class="!h-24 !resize-none"
                        ></textarea>
                    </mat-form-field>
                </mat-expansion-panel>
            </div>

            <div class="w-full">
                <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                        <mat-panel-title
                            class="!text-tertiary-900 font-normal !text-xl py-2"
                        >
                            Order History
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <ag-grid-angular
                        [context]="
                            initializeGridContext(
                                orderDetailsGridType.orderHistoryLogs
                            )
                        "
                        [rowData]="
                            rowData[orderDetailsGridType.orderHistoryLogs]
                        "
                        [gridOptions]="orderHistoryLogsGridOptions"
                        (gridReady)="
                            onGridReady(
                                $event,
                                orderDetailsGridType.orderHistoryLogs
                            )
                        "
                        class="ag-theme-quartz w-full"
                    ></ag-grid-angular>
                </mat-expansion-panel>
            </div>
        }
    </form>

    @if (!hasElevatedRole()) {
        <form [formGroup]="preferredPaymentMethodForm" class="w-full">
            <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                    <mat-panel-title
                        class="!text-tertiary-900 font-normal !text-xl py-2"
                    >
                        Select Payment Method
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="flex flex-col space-y-6 pt-2">
                    <div
                        class="flex items-center gap-6 w-10/12 lg:w-8/12 xl:w-6/12 2xl:w-4/12"
                    >
                        <span class="text-sm text-gray-700 font-medium"
                            >Pay With:</span
                        >
                        <div class="flex items-center gap-4 flex-1">
                            <mat-radio-group
                                class="flex items-center gap-4"
                                [formControl]="
                                    preferredPaymentMethodForm.controls
                                        .paymentMethod
                                "
                                subscriptSizing="dynamic"
                                color="primary"
                            >
                                <mat-radio-button
                                    [value]="paymentMethod.AuthNetAim"
                                    class="text-sm"
                                >
                                    Credit Card
                                </mat-radio-button>
                                @if (isApprovedForInvoiceNet30()) {
                                    <mat-radio-button
                                        [value]="paymentMethod.InvoiceNet30"
                                        class="text-sm"
                                    >
                                        Invoice Net 30 (For Approved Accounts)
                                    </mat-radio-button>
                                }
                            </mat-radio-group>
                            @if (!isApprovedForInvoiceNet30()) {
                                <span
                                    class="inline-flex items-center gap-1.5 ml-auto pl-8 shrink-0"
                                >
                                    <a
                                        [href]="
                                            externalLinks.enterpriseWireless
                                                .creditApplication
                                        "
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        class="text-sm font-bold text-primary-600 hover:text-primary-700 hover:underline"
                                    >
                                        EWA Credit Application
                                    </a>
                                    <app-hover-tooltip
                                        [moreInfo]="true"
                                        [message]="
                                            orderPaymentConstants.INVOICE_NET_30_CREDIT_APPLICATION_TOOLTIP
                                        "
                                    ></app-hover-tooltip>
                                </span>
                            }
                        </div>
                    </div>

                    @if (
                        isAuthNetAim(
                            preferredPaymentMethodForm.controls.paymentMethod
                                .value
                        )
                    ) {
                        <div
                            class="flex flex-col lg:flex-row items-start gap-3 w-full"
                        >
                            <mat-form-field
                                appearance="outline"
                                class="w-10/12 lg:w-8/12 xl:w-6/12 2xl:w-4/12"
                                subscriptSizing="dynamic"
                            >
                                <mat-label>Credit Card</mat-label>
                                <mat-select
                                    [formControl]="
                                        preferredPaymentMethodForm.controls
                                            .cardOnFileId
                                    "
                                    panelWidth="w-full"
                                    placeholder="Please select or add a credit card"
                                >
                                    @for (
                                        cardOption of cardsOnFileDropdownOptions;
                                        track cardOption.value
                                    ) {
                                        <mat-option
                                            [value]="cardOption.value"
                                            [disabled]="cardOption.disabled"
                                        >
                                            {{ cardOption.label }}
                                        </mat-option>
                                    }
                                </mat-select>
                                @if (getCardSelectionError(); as error) {
                                    <mat-error>{{ error }}</mat-error>
                                }
                            </mat-form-field>

                            <div class="flex items-center gap-3 mt-[5px]">
                                <app-card-type-icon
                                    [cardType]="selectedCardOnFile?.cardType"
                                />

                                <button
                                    mat-raised-button
                                    type="button"
                                    name="edit-card"
                                    color="primary"
                                    class="!rounded-lg"
                                    (click)="editSelectedCreditCard()"
                                    [disabled]="
                                        !preferredPaymentMethodForm.controls
                                            .cardOnFileId.value
                                    "
                                >
                                    Edit Card
                                </button>

                                <button
                                    mat-raised-button
                                    type="button"
                                    name="add-new-card"
                                    color="primary"
                                    class="!rounded-lg"
                                    (click)="addNewCreditCard()"
                                >
                                    Add New Card
                                </button>
                            </div>
                        </div>
                    }

                    @if (preferredPaymentMethodForm.enabled) {
                        <div class="flex items-center gap-3 pb-2">
                            <button
                                mat-stroked-button
                                type="button"
                                color="primary"
                                class="!border-primary-700"
                                (click)="resetPreferredPaymentMethodForm()"
                            >
                                Clear
                            </button>
                            <button
                                mat-raised-button
                                type="button"
                                name="save"
                                color="primary"
                                cdkFocusInitial
                                [disabled]="preferredPaymentMethodForm.invalid"
                                (click)="savePreferredPaymentMethodForm()"
                            >
                                Save
                            </button>
                        </div>
                    }
                </div>
            </mat-expansion-panel>
        </form>
    }
</div>
